import { render, staticRenderFns } from "./aBase.vue?vue&type=template&id=70505cd8&scoped=true&"
import script from "./aBase.vue?vue&type=script&lang=js&"
export * from "./aBase.vue?vue&type=script&lang=js&"
import style0 from "./aBase.vue?vue&type=style&index=0&id=70505cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70505cd8",
  null
  
)

export default component.exports